import { getQueryString } from "./get-query";
import { pipeRequest } from "./pipe-request";

export async function updateCard({ oldLead, data, config }) {
  const dataQuery = await getQueryString(data, 'update', config.pipeType, oldLead.fields);

  const id = oldLead.id ?? oldLead.node?.id;

  const query = `mutation{updateFieldsValues(input:{nodeId:${id},values:[${dataQuery}]}){success updatedNode{__typename}}}`;
  const json = await pipeRequest({ query, config });
  return json;
}
